export default __webpack_public_path__ + "static/media/OUR OCEANS.2532e5e0.jpg";